import { render, staticRenderFns } from "./LazyViewportRender.vue?vue&type=template&id=4ebd98b8&"
import script from "./LazyViewportRender.vue?vue&type=script&lang=js&"
export * from "./LazyViewportRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports